import { getCookie } from '@/presentation/libs/cookie.lib';
import { getRoleFromAccessToken } from '@/presentation/router/defaultRoute.router';
import { notify } from '@/presentation/utils';
import { getSubscriptionContext, hasSubscriptionEntitlement } from '@/presentation/modules/dashboard/composables/subscriptionAccess';

const subscriptionEntitlementMiddleware = (router) => {
	router.beforeEach(async (to) => {
		const requiredEntitlement = String(to.meta?.requiredEntitlement || '');
		if (!requiredEntitlement) return true;

		const token = getCookie('access-token');
		if (!token || getRoleFromAccessToken(token) !== 'Business') return true;

		const context = await getSubscriptionContext();
		if (hasSubscriptionEntitlement(context, requiredEntitlement)) return true;

		notify({
			message: 'این قابلیت در پلن فعلی شما فعال نیست. از صفحه اشتراک می‌توانید پلن مناسب را انتخاب کنید.',
			type: 'info',
			duration: 5000,
		});
		return { name: 'DashboardSubscription', query: { locked: requiredEntitlement } };
	});
};

export default subscriptionEntitlementMiddleware;
